import React from 'react';
import { SelectOption } from './select_option';

class Select extends React.Component {
  buildSelectGroup() {
    const result = [];
    this.props.options.map(option => {
      result.push(<SelectOption disabled={option.active === 'false'} value={option.value} displayName={option.displayName} />);
    });
    return result;
  }

  render() {
    return (
      <select className="styled-select" name={this.props.name} value={this.props.value} onChange={this.props.handleChange}>
        {this.buildSelectGroup()}
      </select>
    );
  }
}

export { Select };
